import React from 'react'
import { Fragment } from 'react';
import reactDom from 'react-dom';
import classes from './Modal.module.css';

const Backdrop = props =>{
    document.addEventListener('keydown', function(event){
        if(event.key === "Escape"){
            props.onHideModal();
            console.log('esc presed');
        }
    });
    return <div className={classes.backdrop} onClick={props.onHideModal}/>;
}
const ModalOverlay =props =>{
    return <div className={classes.modal}>
            <div className={classes.content}>
                {props.children}
            </div>
    </div>;
}

const portalElement = document.getElementById('overlays');



const Modal = (props) => {
    return (
        <Fragment>
            {reactDom.createPortal(<Backdrop onHideModal={props.onHideModal}/>, portalElement)}
            {reactDom.createPortal(<ModalOverlay>
                {props.children}
            </ModalOverlay>, portalElement)}
            
        </Fragment>
    )
}

export default Modal
